import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BtnSrc from '../../../../../assets/images/svg/carousel-control.svg';

const Button = styled.button`
  height: 45px;
  margin: 0 0.5rem;
  position: relative;
  width: 45px;
`;

const Container = styled.div`
  width: 320px;
  @media (min-width: 390px) {
    width: 340px;
  }
  @media (min-width: 475px) {
    width: 475px;
  }
  @media (min-width: 768px) {
    width: 604px;
  }
  @media (min-width: 1024px) {
    width: 726px;
  }
`;

const Mask = styled(Container)``;

const Track = styled(Container).attrs({
  as: 'ul'
})`
  left: 0;
  transition: left 375ms ease-in;
`;

const Image = styled(Container).attrs({
  as: 'li'
})`
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
`;

const DotBtn = styled.button`
  background-color: red;
  display: flex;
  height: 0.5rem;
  width: 0.5rem;
  &.active {
    background-color: #0E2D47;
  }
  &:hover {
    background-color: #0E2D47;
  }
`;

// parse track width from window inner width
const trackWidth = () => {
  if (window.innerWidth >= 768) {
    return 604;
  } else if (window.innerWidth >= 475) {
    return 475;
  } else if (window.innerWidth >= 390) {
    return 340;
  } else {
    return 320;
  }
};


/**
 *
 * @param {images}
 * @param {featured_image_id}
 * @returns
 */
const Carousel = ({
  images,
  featured_image_id
}) => {

  const [index, setIndex] = useState(0);
  const [width, setWidth] = useState(`${images.length * trackWidth()}px`);
  const [touchStart, setTouchStart] = useState(0);
  const [swiped, setSwiped] = useState(false);
  const [next, setNext] = useState(false);

  // parse index of next from image array
  const parseIndex = (next) => (next) ? ((index < images.length-1) ? index +1 : 0) : ((index > 0) ? index -1 : images.length -1);

  // handle carousel nav btns
  const onClick = (next) => setIndex(parseIndex(next));

  // handle touch img events
  const onTouchStart = (e) => setTouchStart(e.touches[0].clientX);

  const onTouchMove = (e) => {
    if (!swiped) {
      setSwiped(true);
      if (touchStart > e.touches[0].clientX) {
        setNext(true);
      } else {
        setNext(false);
      }
    }
  }

  const onTouchEnd = () => {
    setIndex(parseIndex(next));
    setSwiped(false);
  }

  useEffect(() => {
    // re-set the carousel track width on re-size
    function handleResize() {
      setWidth(`${images.length * trackWidth()}px`);
    }

    // listen for resize
    window.addEventListener("resize", handleResize);

    // remove event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const showNav = (images && images.length > 1) ? true : false;

  return (
    <Container className="flex flex-col mx-auto lg:mr-6">
      <div className="flex">
        <div className="items-center flex hidden lg:flex">
          {showNav && <Button onClick={() => onClick(false)}><img src={BtnSrc} /></Button>}
        </div>
        <Mask className="overflow-hidden">
          <Track className={`carousel__track relative flex ml-0`} style={{left: `${-trackWidth() * (index)}px`, width: `${width}`}}>
            {images.map(({ id, image }) => (
              <Image key={id} className={`${(id === featured_image_id) ? 'featured' : ''}`}>
                <img alt="Featured Image"
                  onTouchStart={(e) => showNav && onTouchStart(e)}
                  onTouchMove={(e) => onTouchMove(e)}
                  onTouchEnd={(e) => onTouchEnd(e)}
                  src={image.cropped_landscape_lg_600.url} />
              </Image>
            ))}
          </Track>
        </Mask>
        <div className="items-center flex hidden lg:flex">
          {showNav && <Button onClick={() => onClick(true)}><img src={BtnSrc} style={{ transform: 'rotate(180deg)' }} /></Button>}
        </div>
      </div>
      <ul className="carousel-dot-nav flex justify-center mx-0 my-4 list-none">
        {showNav && images.map((img, i) => (
          <li className="px-3" key={i}>
            <DotBtn onClick={() => setIndex(i)} data-index={i} className={`rounded-full ${(i === index) ? 'active' : ''}`} />
          </li>
        ))}
      </ul>
    </Container>
  )
}

Carousel.propTypes = {
  images: PropTypes.array,
  featured_image_id: PropTypes.number
}

export default Carousel;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Activities/Carousel/index.jsx